import { z } from 'zod';
import { PriceSchema } from '~entities/price/model/price.contracts';

export const ExtraServicePersonSchema = z.object({
  type: z.enum(['ADULT', 'CHILD']),
  age: z
    .object({
      from: z.number().int(),
      to: z.number().int(),
    })
    .nullish(),
});

export const ExtraServiceSchema = z.object({
  id: z.string(),
  extraServiceId: z.number().int(),
  quantity: z.number().int(),
  possibleQuantities: z.array(z.number().int()),
  price: PriceSchema,
  pricePerNight: PriceSchema.optional(),
  totalPrice: PriceSchema,
  // Per-person pricing basis (e.g. price is "per adult"); backend sends it for
  // person-based extra services, otherwise null/absent.
  person: ExtraServicePersonSchema.nullish(),
  // Pre-included by a Cockpit offer: locked at checkout (quantity fixed, not
  // removable). Freely addable catalog services are false. Optional so a session
  // served by an older backend still parses (samera/samera#3332).
  mandatory: z.boolean().optional(),
});
